<template>
  <div>
    <img class="princ" src="/img/autonomia.png">
    <img :src="$t('pages.welcome.ripph_img')">
  </div>
</template>
<script>
export default {
  name: 'Logo'
}
</script>
<style lang="scss" scoped>
  img {
    max-width: 20%;
  }
  img.princ {
    max-width: 50%;
  }
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/Logo.vue